export default {
  ASSIGNED: 'ASSIGNED',
  STOCKED: 'STOCKED',
  PICKED_UP: 'PICKED_UP',
  REMOVE_RX:'REMOVE_RX'
};
